export const FILE_TYPES = {
  RAW: 'raw',
  IMAGE: 'image',
  VIDEO: 'video',
  IMAGE_AND_VIDEO: 'image, video',
};
